<template>
  <div
    class="asc-platform-tiles-wrapper"
    data-automation-id="platform_tiles_wrapper"
  >
    <v-container v-if="!loading" class="pa-0 ma-0" fluid>
      <v-row
        v-for="signature in signatures"
        :key="signature.airlineId"
        style="margin: -8px"
      >
        <v-col
          v-if="signatures.length > 1"
          cols="12"
          class="airline-title px-2 pb-2 pt-4"
          no-gutters
        >
          {{ signature.displayName }}
        </v-col>
        <v-col
          v-for="platform in signature.platforms"
          :key="platform.value"
          cols="12"
          sm="4"
          md="3"
          lg="3"
          xl="3"
          class="pa-2"
          style="min-height: 215px"
        >
          <asc-platform-tile
            :value="{
              ...platform,
              ...{
                icaoCode: signature.icaoCode,
                airlineDisplayName: signature.displayName,
              },
            }"
            :platform="platform.text"
            :signatures="platform.signatures"
            :last-modified-date="platform.lastModifiedDate"
            @onPlatformSelect="handlePlatFormSelect"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import AscPlatformTile from '@/components/molecules/AscPlatformTile'

export default {
  name: 'AscPlatformTilesWrapper',

  components: {
    AscPlatformTile,
  },

  props: {
    signatures: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    handlePlatFormSelect(event, value) {
      this.$emit('onPlatformSelect', event, value)
    },
  },
}
</script>

<style lang="scss" scoped>
.asc-platform-tiles-wrapper {
  .airline-title {
    color: $gray-700;
    font-size: 12px;
    letter-spacing: 1px;
    text-transform: uppercase;
  }
}
</style>
